import { css } from '@leafygreen-ui/emotion';
import { fontWeights } from '@leafygreen-ui/tokens';

export const h3Styles = css`
  font-size: 24px;
  line-height: 32px;
  font-weight: ${fontWeights.medium};
`;
